module.exports = __webpack_public_path__ + "static/media/Sand 02.3488512f.jpg";